import React from 'react';
import './ProductGridSkeletons.scss';

const ProductGridSkeletons = ({
  rowsArray = Array.from({ length: 48 }, (_, i) => i + 1),
  styleObj,
}) => {
  return (
    <div className={`product-skeletons ${styleObj}`}>
      {rowsArray.map(key => (
        <div key={key}>
          <div className="product-skeletons__box">
            <div className="product-skeletons__box__header-wrap">
              <div className="product-skeletons__box__animated-bg product-skeletons__box__animated-bg--header-left" />
              <div className="product-skeletons__box__animated-bg product-skeletons__box__animated-bg--header-right" />
            </div>
            <div className="product-skeletons__box__image-wrap">
              <div className="product-skeletons__box__animated-bg product-skeletons__box__animated-bg--image" />
            </div>
            <div className="product-skeletons__box__swatches-wrap">
              {[1, 2, 3, 4, 5].map(i => (
                <div key={`swatch-${i}`} className="circle" />
              ))}
            </div>
            <div className="product-skeletons__box__footer-wrap">
              <div className="product-skeletons__box__animated-bg line title" />
              <div className="product-skeletons__box__animated-bg price" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductGridSkeletons;
